<p-confirmDialog key="addusers" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="Grid2Col">
	<label>School:</label>
	<label class="InfoText">{{ SchoolFullName }}</label>

	<label>Role:</label>
	<label class="InfoText">{{ RoleDesc }}</label>
</div>

<!--Users-->
<div class="TableDiv">
	<p-table
		#mydt
		[value]="lstUser"
		[loading]="UserLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedUsers"
		dataKey="UserID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--UserName-->
				<th>
					<p-columnFilter type="text" field="UserName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SameSchoolDesc-->
				<th>
					<p-columnFilter field="SameSchoolDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSameSchoolDesc
								[ngModel]="value"
								[options]="lstSameSchoolDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="UserName">Username<p-sortIcon field="UserName"></p-sortIcon></th>
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="PersonName">Name<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="SameSchoolDesc">Staff in School<p-sortIcon field="SameSchoolDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-User>
			<tr [pSelectableRow]="User">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ User[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.SameSchool == true ? 'Black' : 'Red'">
					{{ User.SchoolName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="User.SameSchool == true ? 'Black' : 'Red'">
					{{ User.SameSchoolDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add Role</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onCancel()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
